import React from "react";

import { FormInput } from "./FormInput";
import { FormCheckbox } from "components/form/formCheckbox/FormCheckbox";

import { func_validation } from "functions";



/* Props 
 * {
 *      // Label
 *      isInputOptional: false,
 *      isLabelOptional: false,
 *      inputLabel: "", 
 *      inputSideLabel: "", 
 * 
 *      // Input
 *      inputName: "",
 *      inputValue: "",
 *      inputDescription: "",
 *      customInputDescription: "" | JSX,
 * 
 *      // Input Options
 * 		isCheckboxCheckedDefault: false,
 *      isInputDisabled: false, 
 * 
 *      // Custom Input Validation
 *      customValidator_onChange: (checkboxID, value_formatted)=>{ return value; },
 *      isValuePropagationGuarded_onChange: (value_formatted)=>{ return true/false; },
 * 
 *      // Input Propagation
 *      inputStateName: undefined,
 *      propagateValueChange: (inputStateName, value_formatted)=>{},
 *      handleInputChangeExtend: (checkboxID, value_formatted)=>{},
 * 
 *      // Error Display
 *      isErrorWithinRequired: false,
 *      isErrorOptional: false,
 *      isFormSubmissionAttempted: false,
 * 
 *      // Error Checking
 *      customErrorMsgDefault: "",
 *      customErrorValidation: undefined,
 *      customErrorMsg: "",
 * 
 *      // Custom Error
 *      isInputHasError: false,
 *      customErrorDisplayArray: [{ isError: true|false, errorMsg: "" }],
 * 
 *      // Others
 *      className: "",
 *      customInputClassName: "",
 *      formInputCustomTheme: "component-formInputTheme_default",
 *      isMarginBtmOptional: false,
 *      inputCustomOptions: {},
 * }
 */

class FormInput_confirmPresentation extends React.Component {
	constructor(props) {
		super(props);
        this.state = {
        };

        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    handleCheckboxChange(checkboxID, isCheckboxChecked_new) {
        const { inputStateName } = this.props;

        // Value
        let value_formatted = isCheckboxChecked_new;
        
        // Custom Validator
        if (this.props.customValidator_onChange) value_formatted = this.props.customValidator_onChange(checkboxID, value_formatted);

        // Update parent state
        if (this.props.propagateValueChange) {
            if (this.props.isValuePropagationGuarded_onChange) {
                if (this.props.isValuePropagationGuarded_onChange(value_formatted)) this.props.propagateValueChange(inputStateName, value_formatted);
            }
            else this.props.propagateValueChange(inputStateName, value_formatted);
        }
        
        // Extension
        if (this.props.handleInputChangeExtend) this.props.handleInputChangeExtend(checkboxID, value_formatted);
    }

    render() {
        const { className, customInputClassName, formInputCustomTheme, isMarginBtmOptional, //inputCustomOptions, 
                // Label
                isLabelOptional, inputLabel, inputSideLabel, isInputOptional, 
                // Input
                inputName, inputValue, inputDescriptionClassName, inputDescription, customInputDescription, 
                isCheckboxCheckedDefault, isInputDisabled,
                // Error Checking
                isErrorWithinRequired, isErrorOptional, 
                isFormSubmissionAttempted, 
                customErrorMsgDefault, customErrorValidation, customErrorMsg,
                isInputHasError, customErrorDisplayArray } = this.props;

        // Label
        let inputLabelDisplay = (
            <span className="component-formInput-label">
                {inputLabel}
                {(isInputOptional)?"":(<span className="component-formInput-labelAsterisk">*</span>)}
            </span>
        );

        // SideLabel
        let inputSideLabelDisplay = (
            <span className="component-formInput-sideLabel">
                {inputSideLabel}
            </span>
        );
        
        // Error Values
        let isError = false;
        let errorMsg = "";
        
        // Error Checking (Default)
        isError = (isFormSubmissionAttempted && !inputValue);
        errorMsg = (func_validation.isStringTrimNotEmpty(customErrorMsgDefault))?customErrorMsgDefault:"Input is Required";
        
        // Custom Error Checking (Empty)
        if (func_validation.isNotNullUndefined(customErrorValidation)) {
            isError = (customErrorValidation);
            errorMsg = (isError && func_validation.isStringTrimNotEmpty(customErrorMsg))?
                        customErrorMsg:errorMsg;
        }
        
        // Error Display
        let errorDisplay = (isError)?(<span className="component-formInput-errorMessage">{errorMsg}</span>):"";
        
        // Custom Error for Input
        let isInputHasError_formatted = func_validation.isBooleanTrueNotNullUndefined(isInputHasError);

        // Custom Error Display
        let customErrorDisplay = "";
        if (func_validation.isArrayNotEmpty(customErrorDisplayArray)) {
            customErrorDisplay = customErrorDisplayArray.map((customErrorDisplayItem, idx)=>{
                let isError_custom = func_validation.getObjectPropertyValue(customErrorDisplayItem, "isError", false);
                let errorMsg_custom = func_validation.getObjectPropertyValue(customErrorDisplayItem, "errorMsg", "");
                if (func_validation.isBooleanTrueNotNullUndefined(isError_custom) && 
                    func_validation.isStringTrimNotEmpty(errorMsg_custom)) {
                    return (<span className="component-formInput-errorMessage" key={idx}>{errorMsg_custom}</span>);
                }
            });
        }
        
        // Input Options
        // let inputCustomOptions_formatted = (func_validation.isObjectNotEmpty(inputCustomOptions)?inputCustomOptions:{});
        
        return (
            <FormInput className={""+((className)?className+" ":"")+
                                       ((formInputCustomTheme)?formInputCustomTheme+" ":"component-formInputTheme_default ")} 
                isMarginBtmOptional={isMarginBtmOptional}>
                
                <div className="component-formInputConfirm">

                    {/* Label */}
                    {(isLabelOptional)?"":(
                        (inputSideLabel)?(
                            <div className="component-formInput-labelGroup d-flex align-items-center justify-content-between">
                                {inputLabelDisplay}
                                {inputSideLabelDisplay}
                            </div>
                        ):inputLabelDisplay
                    )}
                    
                    {/* Input */}
                    <div className={"component-formInput-input d-flex align-items-center "+
                                    ((customInputClassName)?customInputClassName+" ":"")+
                                    (((isError || isInputHasError_formatted) && !isErrorOptional)?"component-formInput-inputHasError ":"")+
                                    (((isError || isInputHasError_formatted) && isErrorWithinRequired)?"component-formInputConfirm-errorWithin ":"")}>
                        <FormCheckbox 
                            checkboxID={inputName} 
                            mainCheckboxID={inputName} 

							isMainCheckboxChecked={inputValue} 
							isCheckboxCheckedDefault={isCheckboxCheckedDefault}
                            isCheckboxDisabled={isInputDisabled} 

                            handleCheckboxSelectionMain={this.handleCheckboxChange} 
                        />
                        
                        {(inputDescription || customInputDescription)?(
                            <div className="component-formInputConfirm-desc">
                                {(customInputDescription)?(
                                    customInputDescription
                                ):(
                                    <label className={"component-formInputConfirm-descText " +
                                                        (inputDescriptionClassName? inputDescriptionClassName + " ":"")}
                                        htmlFor={inputName}>{inputDescription}</label>
                                )}
                            </div>
                        ):""}
                    </div>
                    
                    {/* Error Message */}
                    {(isErrorOptional)?"":(errorDisplay)}
                    
                    {/* Custom Error Message */}
                    {(customErrorDisplay)?customErrorDisplay:""}
                
                </div>
            </FormInput>
        );
    }
}



const FormInput_confirm = FormInput_confirmPresentation;
export { FormInput_confirm };